import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { messages } from '../../constants/Collection';
import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';

import CatalogRowItem from './CatalogRowItem';

class AlbumRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    blankItem: PropTypes.bool,
    trackCount: PropTypes.number,
    intl: PropTypes.object,
    collectedTrackCount: PropTypes.number,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.ALBUM,
  };

  render() {
    if (this.props.blankItem) {
      return <CatalogRowItem isPlaceholder={true} />;
    }
    let rightColChild;
    if (this.props.collectedTrackCount) {
      rightColChild = this.props.intl.formatMessage(messages.albumPartiallyCollectedThirdText, {
        num: this.props.collectedTrackCount,
      });
    } else {
      rightColChild = this.props.intl.formatMessage(messages.albumFullyCollectedThirdText, {
        num: this.props.trackCount,
      });
    }
    return <CatalogRowItem rightColChild={rightColChild} {...this.props} />;
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const details = getAnnotationsById(state, ownProps.id);
  props.blankItem = !details;
  if (details) {
    props.mainText = details.get('name');
    props.mainTextUrl = details.get('shareableUrlPath');
    props.secondText = details.get('artistName');
    props.trackCount = details.get('trackCount');
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      ownProps.id,
    );
    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: ownProps.id,
      pandoraType: PandoraTypes.ALBUM,
      shareParentSource: {
        shareParentSourceId: ownProps.id,
        shareParentSourceType: PandoraTypes.ALBUM,
      },
    });
    const artist = getAnnotationsById(state, details.get('artistId'));
    if (artist) {
      props.secondTextUrl = artist.get('shareableUrlPath');
    }
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = getInDomain('catalog.utils.isClean')(details);
    props.dominantColor = getDominantColor(details);
  }
  return props;
}

export default injectIntl(connect(mapStateToProps)(AlbumRowItem));
